import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

/**
 * For simple column/row grid system
 * * **col > 0** Grid items are the same width (column width = grid width / column number).
 * * **col = 0** Grid items are auto width but will respect the gap value.
 * * Breakpoint columns variants respects mobile first approach:<br>
 * e.g.: **col="1" colXS="2"** will render grid with 1 column, but after a 'xs' breakpoint it will render grid with 2 column.
 *
 * #### Slots
 * * Default/unnamed for grid content
 *
 * @prop col - Number of columns. (options: 0, 1, 2, 3, 4, 5)
 * @prop colXS - Number of columns above XS breakpoint. (options: /, 0, 1, 2, 3, 4, 5)
 * @prop colSM - Number of columns above SM breakpoint. (options: /, 0, 1, 2, 3, 4, 5)
 * @prop colMD - Number of columns above MD breakpoint. (options: /, 0, 1, 2, 3, 4, 5)
 * @prop colLG - Number of columns above LG breakpoint. (options: /, 0, 1, 2, 3, 4, 5)
 * @prop gap - Margin between columns/rows (options: /, small, medium, large, extraLarge).
 * @prop alignH - Horizontal align content inside grid (options: /, start, center, end).
 * @prop alignV - Vertical align content inside grid (options: /, start, center, end).
 *
 * @slot default - slot for grid content
 */
export default class GridList extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    col: { type: Number, reflect: true },
    colXS: { type: Number, reflect: true },
    colSM: { type: Number, reflect: true },
    colMD: { type: Number, reflect: true },
    colLG: { type: Number, reflect: true },
    gap: { type: String, reflect: true },
    alignH: { type: String, reflect: true },
    alignV: { type: String, reflect: true },
  };

  constructor() {
    super();
    this.gap = 'medium';
  }

  render() {
    return html`
      <main>
        <slot></slot>
      </main>
    `;
  }
}

customElements.get('ef-grid-list') ||
  customElements.define('ef-grid-list', GridList);
